import { PaymentMethodEnum } from 'api-hooks/payment-channel';
import * as Yup from 'yup';

export type ChequeGiroType = {
  chequeGiroId?: string;
  bankAccountId?: string;
  referenceNumber?: string;
  issuedAt?: Date;
  availableAt?: Date;
  expiredAt?: Date;
};

export type ReleaseSaleType = {
  id: { id: string; label: string } | string | null;
  refId: string | null;
  customerId: string | null;
  customerBillingId: string | null;
  amount: number;
  paymentMethodId: string | null;
  paymentableId: string | null;
  chequeNote: ChequeGiroType | null;

  // Information Additional
  adminId: string | null;
  operatorId?: string | null;
  salesmanId?: string | null;
  code: string;
  description: string;
  transactionAt: Date | null;
  transactionSaleType?: string | null;
  total: number;
  paymentMethod?: string;

  previousSale?: {
    customerId: string | null;
    customerBillingId: string | null;
    adminId: string | null;
    operatorId?: string | null;
    salesmanId?: string | null;
    code: string;
    description: string;
    transactionAt: Date | null;
    total: number;
  };
};

export type ReleaseSaleFormType = {
  releaseSale: ReleaseSaleType;
};

export type ReleasePurchaseType = {
  id: { id: string; label: string } | string | null;
  refId: string | null;
  agentId: string | null;
  amount: number;
  paymentMethodId: string | null;
  paymentableId: string | null;
  chequeNote: ChequeGiroType | null;
  paymentMethod?: string;

  //Information Additional
  transactionAt: Date | null;
  total: number;
  agent: string;
  paymentChannel: string;

  isHideAgent?: boolean;
};

export type ReleasePurchaseFormType = {
  releasePurchase: ReleasePurchaseType;
};

export type FormType = {
  number: string;
  requestedAt: Date;
  reason: string;

  releaseSale: ReleaseSaleType;
  releasePurchase: ReleasePurchaseType | null;

  isHideAgent: boolean;
  transactionSaleType: string;
  transactionOrderType: string;

  activitySales: ActivitySaleType[];
  tourSales: TourSaleType[];
  documentSales: DocumentSaleType[];
  flightSales: FlightSaleType[];
  cruiseSales: CruiseSaleType[];
  hotelSales: HotelSaleType[];
  productSales: ProductSaleType[];

  flightPurchases: FlightPurchaseType[];
  hotelPurchases: HotelPurchaseType[];
  activityPurchases: ActivityPurchaseType[];
  cruisePurchases: CruisePurchaseType[];
  documentPurchases: DocumentPurchaseType[];
};

//Activity Type
export type ActivitySaleGuestDetailType = {
  isSelected?: boolean;
  guestId: string;
  guestName: string;
  activityId: string;
  activityName: string;
  date: Date;
  price: number;
  description: string;
  id: string;
  type: string;
  refundPrice: number;
};

export type ActivitySaleAddOnsType = {
  isSelected?: boolean;
  guestId: string;
  guestName: string;
  description: string;
  price: number;
  id: string;
  refundPrice: number;
};

export type ActivitySaleType = {
  id: string;
  isGroupedPrice: boolean;
  activitySaleGuests: ActivitySaleGuestDetailType[];
  activitySaleAddOns: ActivitySaleAddOnsType[];
};

//Hotel
export type HotelSaleAddOnsType = {
  isSelected: boolean;
  guestId: string;
  guestName: string;
  description: string;
  price: number;
  id: string;
  refundPrice: number;
  priceUnit?: number;
  unit?: number;
};

export type HotelSaleGuestType = {
  id: string;
  preferences: any[];
  guestId: string;
  guestName: string;
  isLead: boolean;
};

export type HotelSaleHotelType = {
  checkInStatus: string | null;
  hotelConfirmationCode: string;
  checkIn: Date;
  checkOut: Date;
  detail?: string | null;
  night: number;
  room: number;
  price: number;
  id: string;
  hotelRoomId: string;
  refundPrice: number;
  pax?: number | null;
  isSelected?: boolean;
};

export type HotelSaleType = {
  isSelected: boolean;
  id: string;
  hotelId: string;
  bookingCode?: string | null;
  remark?: string; // deprecated
  isCityTax: boolean;
  cityTax?: string | null;
  hotelSaleGuests: HotelSaleGuestType[];
  hotelSaleAddOns: HotelSaleAddOnsType[];
  hotelSaleHotels: HotelSaleHotelType[];
  defaultCheckInOut?: { in: string; out: string };
};

//Cruise
export type CruiseSaleGuestType = {
  preferences: any[];
  id: string;
  guestId: string;
  guestName: string;
};

export type CruiseSaleDetailsType = {
  isSelected: boolean;
  cruiseRoomNumber: string;
  deck: string;
  basicFare: number;
  portCharge: number;
  tax: number;
  tipping: number;
  description: string;
  id: string;
  guestId: string;
  guestName: string;
  cruiseRoomId: string;
  refundPrice: number;
};

export type CruiseSaleAddOnsType = {
  isSelected: boolean;
  guestId: string;
  description: string;
  price: number;
  id: string;
  refundPrice: number;
};

export type CruiseSaleType = {
  id: string;
  cruiseId: string;
  cruiseShipId: string;
  bookingCode?: string | null;
  startedAt: Date;
  endedAt: Date;
  route: string;
  isGroupedPrice: boolean;
  reminder: boolean;
  reminderDate?: Date | null;
  reminderDescription?: string | null;
  cruiseSaleGuests: CruiseSaleGuestType[];
  cruiseSaleDetails: CruiseSaleDetailsType[];
  cruiseSaleAddOns: CruiseSaleAddOnsType[];
  cruiseRooms: { id: string; label: string }[];
};

//Flight
export type FlightSaleAddOnsType = {
  isSelected?: boolean;
  id: string;
  description?: string;
  price: number;
  guestName: string;
  route: string;
  refundPrice: number;
};

export type FlightSaleGuestType = {
  isSelected?: boolean;
  ticket: string;
  checkInStatus: string | null;
  airlineName: string;
  date: Date;
  detail: string;
  preferenceId?: string | null;
  route: string;
  time: string;
  price: number;
  id: string;
  guestId: string;
  preferences: string[];
  refundPrice: number;

  //additional
  guestName: string;
  preferenceName?: string;
};

export type FlightSaleType = {
  isSelected?: boolean;
  id: string;
  bookingCode?: string | null;
  flightSaleGuests: FlightSaleGuestType[];
  flightSaleAddOns: FlightSaleAddOnsType[];
};

//Document
export type DocumentSaleAddOnsType = {
  isSelected?: boolean;
  description: string;
  id: string;
  guestId: string;
  guestName: string;
  price: number;
  refundPrice: number;
};

export type DocumentSaleGuestType = {
  //Required
  id: string;
  guestId: string;
  guestName: string;
  description?: string;
  price?: number;
  refundPrice: number;

  isSelected?: boolean;
  biometric?: boolean;
  appointmentAt?: Date;
  preferenceName?: string;
  type?: string;
  company?: string;
  coverArea?: string;
  days?: number;
  package?: string;
  startAt?: Date;
  endAt?: Date;
};

export type DocumentSaleType = {
  id: string;
  documentType: string;
  documentSaleGuests: DocumentSaleGuestType[];
  documentSaleAddOns: DocumentSaleAddOnsType[];
};

//Tour
export type TourSaleAddOnsType = {
  isSelected?: boolean;
  description: string;
  id: string;
  guestId: string;
  guestName: string;
  price: number;
  refundPrice: number;
};

export type TourSaleGuestType = {
  isSelected?: boolean;
  id: string;
  guestId: string;
  guestName: string;
  type: string;
  bed: string;
  note: string;
  group: string;
  schedule: string;
  price: number;
  refundPrice: number;
};

export type TourSaleType = {
  id: string;
  tourSaleGuests: TourSaleGuestType[];
  tourSaleAddOns: TourSaleAddOnsType[];
};

//Product
export type ProductSaleGuestType = {
  guestName: string;
  guestPreferences: any[];
};

export type ProductSaleType = {
  id: string;
  productVariantId: string;
  productVariantName: string;
  price: number;
  qty: number;
  description: string;
  isSelected?: boolean;
  refundPrice: number;
};

// ==== Purchase ===

//Flight
export type FlightPurchaseAddOnsType = {
  isSelected?: boolean;
  id: string;
  description?: string;
  price: number;
  guestName: string;
  route: string;
  refundPrice: number;
};

export type FlightPurchaseGuestType = {
  isSelected?: boolean;
  ticket: string | null;
  airlineName: string;
  date: Date;
  detail: string;
  preferenceId?: string;
  route: string;
  time: string;
  price: number;
  id: string;
  guestId: string;
  preferences: string[];
  refundPrice: number;

  //additional
  guestName: string;
  preferenceName: string;
};

export type FlightPurchaseType = {
  isSelected?: boolean;
  id: string;
  bookingCode?: string | null;
  flightPurchaseGuests: FlightPurchaseGuestType[];
  flightPurchaseAddOns: FlightPurchaseAddOnsType[];
};

//Hotel
export type HotelPurchaseAddOnsType = {
  isSelected: boolean;
  guestId: string;
  guestName: string;
  description: string;
  price: number;
  id: string;
  refundPrice: number;
  priceUnit?: number;
  unit?: number;
};

export type HotelPurchaseGuestType = {
  id: string;
  preferences: any[];
  guestId: string;
  guestName: string;
  isLead: boolean;
};

export type HotelPurchaseHotelType = {
  checkIn: Date;
  checkOut: Date;
  detail?: string | null;
  night: number;
  room: number;
  price: number;
  id: string;
  hotelRoomId: string;
  refundPrice: number;
  isSelected: boolean;
};

export type HotelPurchaseType = {
  isSelected: boolean;
  id: string;
  hotelId: string;
  bookingCode?: string | null;
  hotelConfirmation: string;
  remark?: string; //deprcated
  isCityTax: boolean;
  cityTax?: string | null;
  hotelPurchaseGuests: HotelPurchaseGuestType[];
  hotelPurchaseAddOns: HotelPurchaseAddOnsType[];
  hotelPurchaseHotels: HotelPurchaseHotelType[];
  defaultCheckInOut?: { in: string; out: string };
};

//Cruise
export type CruisePurchaseGuestType = {
  preferences: any[];
  id: string;
  guestId: string;
  guestName: string;
};

export type CruisePurchaseDetailsType = {
  isSelected: boolean;
  cruiseRoomNumber: string;
  deck: string;
  basicFare: number;
  portCharge: number;
  tax: number;
  tipping: number;
  description: string;
  id: string;
  guestId: string;
  guestName: string;
  cruiseRoomId: string;
  refundPrice: number;
};

export type CruisePurchaseAddOnsType = {
  isSelected: boolean;
  guestId: string;
  description: string;
  price: number;
  id: string;
  refundPrice: number;
};

export type CruisePurchaseType = {
  id: string;
  cruiseId: string;
  cruiseShipId: string;
  bookingCode?: string | null;
  startedAt: Date;
  endedAt: Date;
  route: string;
  isGroupedPrice: boolean;
  cruisePurchaseGuests: CruisePurchaseGuestType[];
  cruisePurchaseDetails: CruisePurchaseDetailsType[];
  cruisePurchaseAddOns: CruisePurchaseAddOnsType[];
  cruiseRooms: { id: string; label: string }[];
};

export type ActivityPurchaseGuestDetailType = {
  isSelected?: boolean;
  guestId: string;
  guestName: string;
  activityId: string;
  activityName: string;
  date: Date;
  price: number;
  description: string;
  id: string;
  type: string;
  refundPrice: number;
};

export type ActivityPurchaseAddOnsType = {
  isSelected?: boolean;
  guestId: string;
  guestName: string;
  description: string;
  price: number;
  id: string;
  refundPrice: number;
};

export type ActivityPurchaseType = {
  id: string;
  isGroupedPrice: boolean;
  activityPurchaseGuests: ActivityPurchaseGuestDetailType[];
  activityPurchaseAddOns: ActivityPurchaseAddOnsType[];
};

//Document
export type DocumentPurchaseAddOnsType = {
  isSelected?: boolean;
  description: string;
  id: string;
  guestId: string;
  guestName: string;
  price: number;
  refundPrice: number;
};

export type DocumentPurchaseGuestType = {
  //Required
  id: string;
  guestId: string;
  guestName: string;
  description?: string;
  price?: number;
  refundPrice: number;

  isSelected?: boolean;
  biometric?: boolean;
  appointmentAt?: Date;
  preferenceName?: string;
  type?: string;
  company?: string;
  coverArea?: string;
  days?: number;
  package?: string;
  startAt?: Date;
  endAt?: Date;
};

export type DocumentPurchaseType = {
  id: string;
  documentType: string;
  documentPurchaseGuests: DocumentPurchaseGuestType[];
  documentPurchaseAddOns: DocumentPurchaseAddOnsType[];
};

export const refundSchema = () =>
  Yup.object().shape({
    reason: Yup.string().required(),
    requestedAt: Yup.date().required(),

    releaseSale: Yup.object({
      refId: Yup.string().nullable().required(),
      customerId: Yup.string().nullable().required(),
      amount: Yup.number()
        .min(0)
        .transform((value) => (isNaN(value) ? undefined : value))
        .required(),
      paymentMethodId: Yup.string().nullable().required(),

      paymentMethod: Yup.string(), //validation payment method

      chequeNote: Yup.object({
        chequeGiroId: Yup.string().nullable(),
        bankAccountId: Yup.string().nullable(),
        referenceNumber: Yup.string(),
        issuedAt: Yup.date().nullable(),
        availableAt: Yup.date().nullable(),
        expiredAt: Yup.date().nullable(),
      })
        .nullable()
        .when(['paymentMethod'], {
          is: (paymentMethod) => {
            return paymentMethod === PaymentMethodEnum.ChequeGiro;
          },
          then: Yup.object({
            chequeGiroId: Yup.string().nullable().required(),
            bankAccountId: Yup.string().nullable().required(),
            referenceNumber: Yup.string().required(),
            issuedAt: Yup.date().nullable().required(),
            availableAt: Yup.date().nullable().required(),
            expiredAt: Yup.date().nullable().required(),
          }),
        }),
    }),

    isHideAgent: Yup.boolean(), //validation release purchase

    releasePurchase: Yup.object({
      refId: Yup.string().nullable().required(),
      agentId: Yup.string().nullable().required(),
      amount: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0)
        .required(),
      paymentMethodId: Yup.string().nullable().required(),

      paymentMethod: Yup.string(), //validation payment method

      chequeNote: Yup.object({
        chequeGiroId: Yup.string().nullable(),
        bankAccountId: Yup.string().nullable(),
        referenceNumber: Yup.string(),
        issuedAt: Yup.date().nullable(),
        availableAt: Yup.date().nullable(),
        expiredAt: Yup.date().nullable(),
      })
        .nullable()
        .when(['paymentMethod'], {
          is: (paymentMethod) => {
            return paymentMethod === PaymentMethodEnum.ChequeGiro;
          },
          then: Yup.object({
            chequeGiroId: Yup.string().nullable().required(),
            bankAccountId: Yup.string().nullable().required(),
            referenceNumber: Yup.string().required(),
            issuedAt: Yup.date().nullable().required(),
            availableAt: Yup.date().nullable().required(),
            expiredAt: Yup.date().nullable().required(),
          }),
        }),
    }).when('isHideAgent', {
      is: (val) => {
        return val;
      },
      then: Yup.object({
        refId: Yup.string().nullable(),
        agentId: Yup.string().nullable(),
        amount: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .min(0),
        paymentMethodId: Yup.string().nullable(),

        paymentMethod: Yup.string(), //validation payment method

        paymentableId: Yup.string().nullable(),
        chequeNote: Yup.object({
          chequeGiroId: Yup.string().nullable(),
          bankAccountId: Yup.string().nullable(),
          referenceNumber: Yup.string(),
          issuedAt: Yup.date().nullable(),
          availableAt: Yup.date().nullable(),
          expiredAt: Yup.date().nullable(),
        }),
      }).nullable(),
    }),
  });
